import WebFont from 'webfontloader'
import ElliiThemeProvider from 'Common/components/ElliiThemeProvider'
import CategoryHeader from './category/CategoryHeader'
import CategoryCollections from './category/CategoryCollections'

export default function Category() {
  WebFont.load({
    google: {
      families: ['Open Sans:400,400italic,600,700'],
    },
  })

  return (
    <ElliiThemeProvider>
      <CategoryHeader />
      <CategoryCollections />
    </ElliiThemeProvider>
  )
}
